import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=46fb2ad8&scoped=true"
import script from "./Total.vue?vue&type=script&lang=js"
export * from "./Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb2ad8",
  null
  
)

export default component.exports